<template>
    <el-dialog title="系统自动运算税率配置" :visible="visible" :show="show" width="40%"     :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="290px">
            <el-form-item label="煤炭价格税率（含税÷税率=不含税）" class="input" prop="taxPoint">
                <el-input-number :controls="false" v-model="ruleForm.taxPoint" :step="0.1" autocomplete="off"
                                 placeholder="请输入煤炭价格税率" style="width:90%"></el-input-number>
            </el-form-item>
            <el-form-item label="运费税率（不含税÷税率=含税）" class="input" prop="freightPoint">
                <el-input-number :controls="false" v-model="ruleForm.freightPoint" :step="0.1" autocomplete="off"
                                 placeholder="请输入运费税率" style="width:90%"></el-input-number>
            </el-form-item>
            <el-form-item label="场地税率（含税÷税率=不含税）" class="input" prop="stationPoint">
                <el-input-number :controls="false" v-model="ruleForm.stationPoint" :step="0.1" autocomplete="off"
                                 placeholder="请输入场地税率" style="width:90%"></el-input-number>
            </el-form-item>

            <el-form-item label="铁路运费税率" class="input" prop="carTaxPoint" v-if="role==='管理员'">
                <el-input-number :controls="false" v-model="ruleForm.carTaxPoint" :step="0.1" autocomplete="off"
                                 placeholder="请输入铁路运费税率" style="width:90%"></el-input-number>
            </el-form-item>
            <el-form-item label="港杂费税率" class="input" prop="gzTaxPoint" v-if="role==='管理员'">
                <el-input-number :controls="false" v-model="ruleForm.gzTaxPoint" :step="0.1" autocomplete="off"
                                 placeholder="请输入港杂费税率" style="width:90%"></el-input-number>
            </el-form-item>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.role = this.$storage.get("role");
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    brokenPrice:'',
                    fallHots:'',
                    taxPoint:'',
                    gzTaxPoint:'',
                },
                role:'',
                rules:{
                    freightPoint:[{ required: true, message: '请输入运费税率', trigger: 'blur' }],
                    stationPoint:[{ required: true, message: '请输入场地费税率', trigger: 'blur' }],
                    taxPoint:[{ required: true, message: '请输入不含税煤源税率', trigger: 'blur' }],
                    carTaxPoint:[{ required: true, message: '请输入不含税铁路运费税率', trigger: 'blur' }],
                },
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`baseCocalConfig/`+"save":this.url+`baseCocalConfig/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: data.msg,
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>